<template>
  <!-- <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{kid_id ? 'Update' : 'Create'}} Kid</p>
      </header> -->
      <div class="columns">
        <div class="column is-12" >
          <!--Loading-->
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Name">
            <b-input v-model="kid.name" ref="name" required type="text" placeholder="Add kid name here"></b-input>
          </b-field>
          <b-field label="Date of Birth">
            <b-datepicker v-model="kid.dob" ref="dob" required placeholder="Add your kid's date of birth here"></b-datepicker>
          </b-field>
        
          <div class="mt-2 is-centered columns"><b-button class="is-centered" @click="proceed()" type="is-success">{{kid_id ? 'Update' : 'Create'}}</b-button></div>
        </div>
      </div>
    <!-- </div>
  </form> -->
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-kid",
  data() {
    return {
      announcementfiles: null,
      isLoading: false,
      kid : {
        name : "",
        dob : null
      }
    };
  },
  props: {
    kid_id: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentKid"]),
  },
  methods: {
    ...mapActions([
      "createKid",
      "updateKid",
      "loadKidDetails",
    ]),
    proceed() {
      let is_validate = this.$refs.name.checkHtml5Validity() && this.$refs.dob.checkHtml5Validity();
      if (is_validate) {
        this.isLoading = true;
        if (this.kid_id) {
          //For editing 
          this.updateKid({
            id: this.kid_id,
            kid: this.kid,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Kid account updated successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            console.log(err)
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        } else {
          //For creating
          this.createKid({
            kid : this.kid,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Kid account created successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        }
      }
    },
    async loadKid(id){
      if (id) {
        this.isLoading = true;
        await this.loadKidDetails({
          id: id,
          token: this.getTeacherToken,
        });

        this.kid.name = this.fetchCurrentKid.name;
        this.kid.dob = new Date(this.fetchCurrentKid.dob)
        this.isLoading = false;
      }
    }
  },
  watch : {
    kid_id : function(new_val){
      if(new_val){
        this.loadKid(new_val)
      }else{
        this.kid.name = ""
        this.kid.dob = ""
      }
    }
  },
  created() {
    this.loadKid(this.kid_id)
  },
};
</script>
<style scoped>
</style>